import { Input } from '@shared/ui/kit';
import styles from './email-subject-field.module.scss';

interface EmailSubjectFieldProps {
  label: string;
  subject: string;
  onSubjectChange: (value: string) => void;
}

export const EmailSubjectField = ({ label, subject, onSubjectChange }: EmailSubjectFieldProps) => (
  <div className={styles.fieldWrapper}>
    <div className={styles.fieldHeader}>
      <p className={styles.fieldLabel}>{label}</p>
    </div>
    <Input
      size="small"
      labelText=""
      placeholder="Введите тему письма"
      value={subject}
      changeFunction={(value: string) => onSubjectChange(value)}
      settings={{ width: '100%' }}
    />
  </div>
);
